<h4 mat-dialog-title>{{ 'SEGNALAZIONE.nuova_segnalazione' | translate }}</h4>
<mat-dialog-content (click)="clearSelectedPatient()">
  <p class="text-sm">
    {{ 'SEGNALAZIONE.cerca_paziente' | translate }}
  </p>
  <form [formGroup]="form" class="rounded-lg container pt-4">
    <div class="grid grid-cols-2 gap-4 mb-3">
      <siat-input-field
        [formGroup]="form"
        controlName="nome"
        id="nome"
        name="nome"
        placeholder="{{ 'SEGNALAZIONE.input_placeholder' | translate }}"
        label="{{ 'FIELDS.NAME.label' | translate }}"
      ></siat-input-field>
      <siat-input-field
        [formGroup]="form"
        controlName="cognome"
        id="cognome"
        name="cognome"
        placeholder="{{ 'SEGNALAZIONE.input_placeholder' | translate }}"
        label="{{ 'FIELDS.SURNAME.label' | translate }}"
      ></siat-input-field>
      <siat-input-field
        class="col-span-2"
        [formGroup]="form"
        controlName="codiceFiscale"
        id="codiceFiscale"
        name="codiceFiscale"
        placeholder="{{ 'SEGNALAZIONE.input_placeholder' | translate }}"
        label="{{ 'FIELDS.FISCAL_CODE.label' | translate }}"
      ></siat-input-field>
    </div>
    @if (form.errors?.['fieldsRequired'] && form.touched) {
      <p
        class="alert alert-danger"
        role="alertdialog"
        [attr.aria-label]="'GENERAL.campoObbligatorio' | translate"
      >
        È obbligatorio compilare Nome e Cognome oppure il Codice Fiscale.
      </p>
    }
    @if (
      checkLength(form.controls['nome']?.value) ||
      checkLength(form.controls['cognome']?.value)
    ) {
      <p
        class="alert alert-danger"
        role="alertdialog"
        [attr.aria-label]="'Inserito meno di 3 caratteri nel nome'"
      >
        Con meno di 3 caratteri la ricerca viene effettuata in modo puntuale.
        Per ottenere risultati più ampi, inserisci almeno 3 caratteri.
      </p>
    }
    <div class="flex flex-row justify-end my-5">
      <button
        matButton=""
        type="button"
        (click)="clearFields()"
        class="mr-3"
        [attr.aria-label]="'SEGNALAZIONE.pulisci_campi' | translate"
      >
        {{ 'SEGNALAZIONE.pulisci_campi' | translate }}
      </button>
      <button
        matButton="filled"
        type="submit"
        [disabled]="!form.valid"
        [attr.aria-label]="'GENERAL.search' | translate"
        (click)="searchPatients()"
        class="search-button"
      >
        <mat-icon>search</mat-icon>
        {{ 'GENERAL.search' | translate }}
      </button>
    </div>

    @if ((searchResults | async)?.length > 0) {
      @if (searchResults | async; as results) {
        <mat-divider></mat-divider>
        <div class="rounded-md p-4 bg-surface-container-high my-4">
          <div class="text-base mb-3 font-normal">
            {{ 'GENERAL.results' | translate }}
          </div>
          <div class="flex flex-col">
            @for (patient of results; track patient?.codiceFiscale) {
              <div class="mb-3">
                <button
                  matButton="text"
                  class="patient-result flex-1 h-auto! w-full rounded-md cursor-pointer transition-colors duration-200 outline-none hover-section justify-start!"
                  (click)="$event.stopPropagation(); onPatientSelected(patient)"
                  (keydown)="onPatientKeyDown($event, patient)"
                  tabindex="0"
                  role="button"
                  [attr.aria-label]="
                    'Select patient ' + patient.nome + ' ' + patient.cognome
                  "
                  [ngClass]="{
                    'bg-secondary-container': selectedPatient === patient,
                  }"
                >
                  <div class="flex items-center gap-3 p-3">
                    @if (patient.fromAsuit) {
                      <img
                        src="assets/images/asuit.png"
                        alt="ASUIT"
                        matTooltip="Paziente ASUIT"
                        width="20"
                        height="20"
                        class="shrink-0"
                      />
                    }
                    <div class="flex flex-col">
                      <div
                        class="text-base font-normal text-left"
                        [ngClass]="{
                          'text-on-secondary-container':
                            selectedPatient === patient,
                        }"
                      >
                        {{ patient.nome }} {{ patient.cognome }} -
                        <span class="font-light">
                          {{ patient.dataNascita | date: 'dd/MM/yyyy' }}
                        </span>
                      </div>
                      <div
                        class="text-base font-light text-left"
                        [ngClass]="{
                          'text-on-secondary-container':
                            selectedPatient === patient,
                        }"
                      >
                        @if (patient.codiceFiscale) {
                          {{ patient.codiceFiscale }} -
                        }
                        {{
                          patient.sesso === 'M'
                            ? 'Maschio'
                            : patient.sesso === 'F'
                              ? 'Femmina'
                              : patient.sesso === 'X'
                                ? 'Altro'
                                : 'Non definito'
                        }}
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            }
          </div>
        </div>
      }
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions
  class="flex justify-between! items-center w-full"
  [align]="'start'"
>
  <div>
    <button
      matButton="outlined"
      type="button"
      [attr.aria-label]="'SEGNALAZIONE.nuovo_paziente' | translate"
      (click)="onNewPatient()"
    >
      <mat-icon>add</mat-icon>
      {{ 'SEGNALAZIONE.nuovo_paziente' | translate }}
    </button>
  </div>

  <div class="flex items-center gap-2 justify-between">
    <button
      matButton="tonal"
      (click)="dialogRef.close()"
      type="button"
      [attr.aria-label]="'COMMON.annulla' | translate"
    >
      {{ 'COMMON.annulla' | translate }}
    </button>
    <button
      matButton="filled"
      [attr.aria-label]="'COMMON.avanti' | translate"
      type="submit"
      (click)="onSubmit()"
      [disabled]="!form.valid"
    >
      {{ 'COMMON.avanti' | translate }}
    </button>
  </div>
</mat-dialog-actions>
